module.exports = __webpack_public_path__ + "static/media/apple-touch-startup-image-1125x2436.c160c6a2.png";